<template>
	<div class="font-sans container shadow px-4 mx-auto">
		<header class="sm:flex bg-white items-center pt-4 pb-5 px-4 sm:px-8 md:px-12">
			<div class="sm:w-1/2">
				<img class="mx-auto h-12 sm:ml-0" :src="require('@/assets/pace-logo.svg')">
			</div>
			<div class="mt-2 text-center sm:w-1/2 sm:mt-0 sm:text-right">
				<a class="whitespace-no-wrap text-pace-green font-bold text-xl sm:text-2xl" href="tel:1-800-444-7233">1-800-444-7223</a>
			</div>
		</header>

		<section class="bg-header-dark bg-gradient-to-r shadow-lg relative from-header-dark via-header-light to-header-dark text-white px-4 pt-3 sm:pt-4 md:px-8 md:py-8">
			<h1 class="text-center text-2xl font-bold sm:text-4xl md:text-left md:text-5xl md:leading-tight md:max-w-md">KITTING/CUSTOM CABLING</h1>
			<div class="mt-2 h-1 bg-pace-green mx-auto max-w-sm sm:max-w-lg md:mx-0 md:max-w-xs"></div>
			<p class="mt-2 italic text-lg max-w-sm mx-auto text-center sm:text-xl md:mx-0 md:text-left md:max-w-xs md:text-2xl md:pb-0">Providing you with any cables you need in a variety of sizes and colors.</p>
			<div class="mt-4 flex justify-around mx-6 h-32 sm:h-40 md:hidden">
				<img class="object-scale-down object-top" src="@/assets/Fiber.png">
				<img class="object-scale-down object-top" src="@/assets/Cat-6.png">
				<img class="object-scale-down object-top" src="@/assets/HDMI.png">
				<img class="object-scale-down object-top" src="@/assets/Coax.png">
			</div>
			<div class="hidden absolute h-full right-0 bottom-0 pt-8 pr-8 md:block">
				<img class="h-full object-scale-down object-center" :src="require('@/assets/Cables.png')">
			</div>
		</section>

		<main class="bg-white px-4 py-8 sm:px-6 md:px-8 md:py-10">
			<p class="text-center sm:text-lg">Ordering from multiple locations can lead to an increase in costs. Speak with Pace to learn how our full-service distribution center can deliver solutions to your projects on-time, pre-built, and ready to light up.</p>

			<h3 class="mt-4 mx-auto text-2xl text-center border-t border-b border-black py-1 text-gray-700 font-bold max-w-sm sm:max-w-lg sm:text-3xl md:text-4xl">Claim Your FREE Samples!</h3>

			<form @submit.prevent="submit" class="mt-6 sm:mt-8 md:mt-10">
				<div class="md:flex items-center">
					<div class="md:w-1/2 md:pr-4">
						<div class="md:flex">
							<div class="md:w-1/2 md:pr-2">
								<label class="font-medium block pl-1" for="name">Name</label>
								<input class="py-1 px-2 shadow-inner border w-full" name="name" v-model="name" autocomplete="name" required type="text">
							</div>

							<div class="mt-2 sm:mt-4 md:mt-0 md:w-1/2 md:pl-2">
								<label class="font-medium block pl-1" for="phone">Phone Number</label>
								<input class="py-1 px-2 shadow-inner border w-full" name="phone" v-model="phone" autocomplete="tel" required type="tel">
							</div>
						</div>

						<div class="mt-2 sm:mt-4">
							<label class="font-medium block pl-1" for="email">Email</label>
							<input class="py-1 px-2 shadow-inner border w-full" name="email" v-model="email" autocomplete="email" required type="email">
						</div>

						<div class="mt-2 sm:mt-4">
							<div class="flex justify-between px-1">
								<label class="font-medium block" for="company">Company</label>
								<p class="text-sm text-gray-600">Optional</p>
							</div>
							<input class="py-1 px-2 shadow-inner border w-full" name="company" v-model="company" autocomplete="work" type="text">
						</div>

						<div class="mt-2 sm:mt-4">
							<label class="font-medium block pl-1" for="address">Address</label>
							<input class="py-1 px-2 shadow-inner border w-full" name="address" v-model="address" autocomplete="street-address" type="text">
						</div>

						<div class="mt-2 sm:mt-4">
							<label class="font-medium block pl-1" for="city">City</label>
							<input class="py-1 px-2 shadow-inner border w-full" name="city" v-model="city" autocomplete="address-level2" required type="text">
						</div>

						<div class="md:flex md:mt-4">
							<div class="mt-2 sm:mt-4 md:mt-0 md:w-2/3 md:pr-2">
								<label class="font-medium block pl-1" for="state">State</label>
								<select class="py-1 px-2 shadow-inner border w-full" required autocomplete="address-level1" name="state" v-model="state">
									<option value=""></option>
									<option value="AL">Alabama</option>
									<option value="AK">Alaska</option>
									<option value="AZ">Arizona</option>
									<option value="AR">Arkansas</option>
									<option value="CA">California</option>
									<option value="CO">Colorado</option>
									<option value="CT">Connecticut</option>
									<option value="DE">Delaware</option>
									<option value="FL">Florida</option>
									<option value="GA">Georgia</option>
									<option value="HI">Hawaii</option>
									<option value="ID">Idaho</option>
									<option value="IL">Illinois</option>
									<option value="IN">Indiana</option>
									<option value="IA">Iowa</option>
									<option value="KS">Kansas</option>
									<option value="KY">Kentucky</option>
									<option value="LA">Louisiana</option>
									<option value="ME">Maine</option>
									<option value="MD">Maryland</option>
									<option value="MA">Massachusetts</option>
									<option value="MI">Michigan</option>
									<option value="MN">Minnesota</option>
									<option value="MS">Mississippi</option>
									<option value="MO">Missouri</option>
									<option value="MT">Montana</option>
									<option value="NE">Nebraska</option>
									<option value="NV">Nevada</option>
									<option value="NH">New Hampshire</option>
									<option value="NJ">New Jersey</option>
									<option value="NM">New Mexico</option>
									<option value="NY">New York</option>
									<option value="NC">North Carolina</option>
									<option value="ND">North Dakota</option>
									<option value="OH">Ohio</option>
									<option value="OK">Oklahoma</option>
									<option value="OR">Oregon</option>
									<option value="PA">Pennsylvania</option>
									<option value="RI">Rhode Island</option>
									<option value="SC">South Carolina</option>
									<option value="SD">South Dakota</option>
									<option value="TN">Tennessee</option>
									<option value="TX">Texas</option>
									<option value="UT">Utah</option>
									<option value="VT">Vermont</option>
									<option value="VA">Virginia</option>
									<option value="WA">Washington</option>
									<option value="WV">West Virginia</option>
									<option value="WI">Wisconsin</option>
									<option value="WY">Wyoming</option>
								</select>
							</div>

							<div class="mt-2 sm:mt-4 md:mt-0 md:w-1/3 md:pl-2">
								<label class="font-medium block pl-1" for="zip">Zip</label>
								<input class="py-1 px-2 shadow-inner border w-full" name="zip" v-model="zip" autocomplete="postal-code" required type="text">
							</div>
						</div>
					</div>

					<div class="mt-8 md:mt-0 md:w-1/2 md:pl-4">
						<h3 class="text-xl font-semibold text-gray-700 text-center sm:text-2xl md:text-3xl">Select Your Samples</h3>

						<div class="flex flex-wrap justify-around">
							<div class="w-1/2 px-1 mt-4">
								<label class="flex justify-center items-center rounded border py-4 cursor-pointer" :class="{ 'bg-pace-green text-white': samples.fiber }">
									<input class="hidden" v-model="samples.fiber" type="checkbox" name="fiber">
									<span class="text-lg sm:text-xl md:text-2xl" for="fiber">Fiber</span>
									<svg v-if="samples.fiber" class="ml-2 h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
										<polyline points="20 6 9 17 4 12"></polyline>
									</svg>
								</label>
							</div>                

							<div class="w-1/2 px-1 mt-4">
								<label class="flex justify-center items-center rounded border py-4 cursor-pointer" :class="{ 'bg-pace-green text-white': samples.coax }">
									<input class="hidden" v-model="samples.coax" type="checkbox" name="coax">
									<span class="text-lg sm:text-xl md:text-2xl" for="coax">Coax</span>
									<svg v-if="samples.coax" class="ml-2 h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
										<polyline points="20 6 9 17 4 12"></polyline>
									</svg>
								</label>
							</div>

							<div class="w-1/2 px-1 mt-4">
								<label class="flex justify-center items-center rounded border py-4 cursor-pointer" :class="{ 'bg-pace-green text-white': samples.ethernet }">
									<input class="hidden" v-model="samples.ethernet" type="checkbox" name="ethernet">
									<span class="text-lg sm:text-xl md:text-2xl" for="ethernet">Ethernet</span>
									<svg v-if="samples.ethernet" class="ml-2 h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
										<polyline points="20 6 9 17 4 12"></polyline>
									</svg>
								</label>
							</div>

							<div class="w-1/2 px-1 mt-4">
								<label class="flex justify-center items-center rounded border py-4 cursor-pointer" :class="{ 'bg-pace-green text-white': samples.hdmi }">
									<input class="hidden" v-model="samples.hdmi" type="checkbox" name="hdmi">
									<span class="text-lg sm:text-xl md:text-2xl" for="hdmi">HDMI</span>
									<svg v-if="samples.hdmi" class="ml-2 h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
										<polyline points="20 6 9 17 4 12"></polyline>
									</svg>
								</label>
							</div>
						</div>

						<div class="mt-2 sm:mt-4 md:mt-8">
							<div class="flex justify-between px-1">
								<label class="font-medium block" for="comments">Comments</label>
								<p class="text-sm text-gray-600">Optional</p>
							</div>
							<textarea class="h-32 py-1 px-2 shadow-inner border w-full" name="comments" v-model="comments" autocomplete="off"></textarea>
						</div>
					</div>
				</div>

				<button :disabled="isLoading" class="mt-8 text-center w-40 rounded-full mx-auto block py-2 bg-pace-green text-white font-bold tracking-wide text-lg sm:w-48 sm:text-xl" :class="{ 'cursor-not-allowed': isLoading }">{{ isLoading ? 'Submitting...' : 'Claim Now' }}</button>
			</form>
		</main>

		<footer class="bg-footer-brown text-white py-4 px-4 sm:py-6 md:py-8">
			<h3 class="text-center text-xl font-medium md:text-2xl lg:text-4xl lg:mx-32">Contact one of our Account Managers for more information.</h3>

			<div class="sm:flex justify-around mt-4 sm:mt-6 md:mt-8 lg:mt-10">

				<div class="flex flex-col text-center mt-4">
					<img class="mx-auto rounded-full h-40 w-40 border border-black object-cover object-center" :src="require('@/assets/Danny.jpg')">
					<h4 class="mt-3 text-lg font-semibold md:text-xl">Danny Malecha</h4>
					<a class="italic" href="tel:507-424-5584">507-424-5584</a>
					<a class="italic -mt-1" href="mailto:danny@paceintl.com">Danny@paceintl.com</a>
				</div>

				<div class="flex flex-col text-center mt-4">
					<img class="mx-auto rounded-full h-40 w-40 border border-black object-cover object-center" :src="require('@/assets/Joe.jpg')">
					<h4 class="mt-3 text-lg font-semibold md:text-xl">Joe Wente</h4>
					<a class="italic" href="tel:507-424-4912">507-424-4912</a>
					<a class="italic -mt-1" href="mailto:joe@paceintl.com">Joe@paceintl.com</a>
				</div>

			</div>
		</footer>
		<aside v-if="success" class="fixed inset-0 flex items-center justify-center px-8 py-16">
			<div class="bg-black opacity-75 absolute inset-0"></div>

			<div class="relative bg-white shadow py-4 px-8 rounded">
				<h3 class="text-header-dark text-4xl tracking-wide text-center font-bold">Thanks!</h3>

				<p class="text-lg text-center max-w-xs">We have received your request and we'll be in touch!</p>
			</div>
		</aside>
	</div>
</template>

<script>
	import objectFitImages from 'object-fit-images'
	import axios from 'axios'
	
	export default {
		data: () => ({
			name: '',
			phone: '',
			email: '',
			company: '',
			address: '',
			city: '',
			state: '',
			zip: '',
			comments: '',
			samples: {
				fiber: false,
				coax: false,
				ethernet: false,
				hdmi: false,
			},

			success: false,
			isLoading: false,
		}),

		methods: {
			submit() {
				if (this.isLoading) {
					return
				}

				this.isLoading = true

				axios.post('/.netlify/functions/send-email', {
					name: this.name,
					company: this.company,
					address: this.address,
					city: this.city,
					state: this.state,
					zip: this.zip,
					phone: this.phone,
					email: this.email,
					comments: this.comments,
					cables: [
						...this.samples.fiber ? ['Fiber'] : [],
						...this.samples.coax ? ['Coax'] : [],
						...this.samples.ethernet ? ['Ethernet'] : [],
						...this.samples.hdmi ? ['HDMI'] : [],
					].join(', '),
				}).then(() => {
					this.success = true
					this.isLoading = false
				})
			},
		},

		mounted() {
			objectFitImages()
		},
	}
</script>

<style>
	.object-scale-down.object-top {
		@apply object-scale-down object-top;
	}

	.object-cover.object-center {
		@apply object-cover object-center;
	}
</style>
